<template>
  <!-- <nav-menu></nav-menu> -->
  <router-view />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
@Options({
  components: {
  },
})
export default class App extends Vue {}
</script>

<style>
#app {
  font-family: 'PT Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.color-red {
  color:red;
}

.color-orange {
  color:orange;
}

.no-overflow {
  overflow: hidden;
}
</style>
